export function viewFile(file: File) {
  window.location.href = URL.createObjectURL(file);
}



// WEBPACK FOOTER //
// ./src/shared/helpers/viewFile.ts